import greenRedCircleIcon from '@/pages/dashboard/assets/svg/green-red-circle.svg';
export const iconMap ={
  "greenRedCircle": greenRedCircleIcon
};